<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<draggable-container
	#dragContainer
	*ngIf="showUndo$ | async"
	[resizable]="false"
	[width]="200"
	[y]="91"
	[iconType]="'close'"
	[deadZoneSize]="0"
	[containerType]="containerType"
	(close)="togglePanel()"
>
	<div class="panel-sm">
		<div class="undo-header">
			{{ AppStrings.UNDO_PANEL_HEADER }}
			<div class="undo-header-desc">
				{{ AppStrings.UNDO_PANEL_DESC }}
			</div>
		</div>

		<div *ngIf="(list$ | async).length > 0">
			<div class="changes-list-label">{{ AppStrings.UNDO_PANEL_MOST_RECENT_CHANGES }}</div>
			<div class="undo-section-divider-line"></div>
			<div class="undo-redo-label">
				<div>{{ AppStrings.UNDO_PANEL_UNDO }}</div>
				<div>{{ AppStrings.UNDO_PANEL_REDO }}</div>
			</div>

			<div class="action-list-container">
				<div class="action-list">
					<!-- <div class="panel-cell" *ngIf="(selectedIndex$ | async) !== -1" (click)="applyUndo(-1)">Select -1</div> -->
					<ng-container *ngFor="let undoItem of list$ | async; index as i">
						<div
							class="panel-cell"
							[ngClass]="{ redo: (selectedIndex$ | async) >= i }"
							*ngIf="!undoItem.isInvalid"
							(click)="applyUndo(i)"
						>
							<div class="undo-item-title">
								<mat-icon class="undo-icon" aria-hidden="false">undo</mat-icon>
								{{ undoItem.title }}
								<mat-icon class="redo-icon" aria-hidden="false">redo</mat-icon>
							</div>
						</div>
						<div class="panel-cell invalidated-panel" *ngIf="undoItem.isInvalid">
							<div class="invalid-item-title">
								<mat-icon aria-hidden="false">block</mat-icon>
								<span class="invalid-item-title-text">{{ undoItem.title }}</span>
								<mat-icon aria-hidden="false">block</mat-icon>
							</div>
						</div>

						<div
							class="undo-redo-divider-line"
							*ngIf="i === (selectedIndex$ | async) && i !== (list$ | async).length - 1"
						></div>

						<!-- divider line always present -->
						<!-- <div class="undo-redo-divider-line" *ngIf="i === (selectedIndex$ | async)"></div> -->
					</ng-container>
					<div *ngIf="lock$ | async" class="lock-overlay" style="position: absolute; height: 100%">
						<i class="material-icons" [ngStyle]="{ 'font-size': (listSize$ | async) === 1 ? '15px' : '30px' }"
							>lock</i
						>
					</div>
				</div>
			</div>

			<div class="undo-section-divider-line"></div>
			<div class="changes-list-label">{{ AppStrings.UNDO_PANEL_PREVIOUS_CHANGES }}</div>
		</div>
	</div>
</draggable-container>
